export const approveAttendanceApi = {
    heading:[

        {
            head:"Name"
        },
        {
            head:"Employee ID"
        },
        {
            head:"Date"
        },
        {
            head:"Original Punch"
        },
        {
            head:"Req. In Time"
        },       
        {
            head:"Req. Out Time"
        },       
        {
            head:"Status"
        },
    ],
    data:[
       {
        name:"Shan Ahmed",
        empid:1138,
        date:"06-08-2023",
        oripunch:"07:25AM",
        reqintime:"7:00:AM",
        reqouttime:"11:00:AM",
        status:"pending"
    },
       {
        name:"Shan Ahmed",
        empid:1138,
        date:"06-08-2023",
        oripunch:"07:25AM",
        reqintime:"7:00:AM",
        reqouttime:"11:00:AM",
        status:"pending"
    },
       {
        name:"Shan Ahmed",
        empid:1138,
        date:"06-08-2023",
        oripunch:"07:25AM",
        reqintime:"7:00:AM",
        reqouttime:"11:00:AM",
        status:"pending"
    },
    
     
       
     
       
    ]
}